import { Directive, ElementRef, HostListener, inject, input, output } from "@angular/core";

@Directive({
  selector: "[appClickOutside]",
  standalone: true,
})
export class ClickOutsideDirective {
  private readonly elementRef = inject(ElementRef);

  isActive = input<boolean>(true);

  clickOutside = output<void>();

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event): void {
    if (!this.isActive()) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(event.target as Node);

    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
